import { isDesktop, isTablet } from 'shared/utils/deviceClassUtils'

export const getDevicePlatform = deviceClass => {
  if (isDesktop(deviceClass)) {
    return 'desktop'
  }
  if (isTablet(deviceClass)) {
    return 'tablet'
  }

  return 'mobile'
}
